import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-split-large.tsx
/**
* icon.24.split.large
*
* Keywords: waveform, audio, sound, frequency, equalizer, vertical, bars, music
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDNhMS45OTggMS45OTggMCAwIDEgLjUgMy45MzRWOC41QTIuNSAyLjUgMCAwIDAgMTUgMTFoLjVhMi41IDIuNSAwIDAgMSAyLjUgMi41djQuNzkzbDIuMTQ2LTIuMTQ2YS41LjUgMCAwIDEgLjcwNy43MDdsLTMgM2EuNS41IDAgMCAxLS4xMTMuMDgyLjUuNSAwIDAgMS0uMzM5LjA1NC41LjUgMCAwIDEtLjE2NC0uMDY2bC0uMDE0LS4wMDdhLjUuNSAwIDAgMS0uMDc3LS4wNjRsLTMtM2EuNS41IDAgMCAxIC43MDctLjcwN0wxNyAxOC4yOTNWMTMuNWExLjUgMS41IDAgMCAwLTEuNS0xLjVIMTVhMy41IDMuNSAwIDAgMS0zLTEuNjk4QTMuNSAzLjUgMCAwIDEgOSAxMmgtLjVBMS41IDEuNSAwIDAgMCA3IDEzLjV2NC43OTNsMi4xNDYtMi4xNDZhLjUuNSAwIDEgMSAuNzA3LjcwN2wtMyAzYS41LjUgMCAwIDEtLjExMy4wODIuNS41IDAgMCAxLS4zMzkuMDU0LjUuNSAwIDAgMS0uMTQyLS4wNTQuNS41IDAgMCAxLS4xMTMtLjA4MmwtMy0zYS41LjUgMCAxIDEgLjcwNy0uNzA3TDYgMTguMjkzVjEzLjVBMi41IDIuNSAwIDAgMSA4LjUgMTFIOWEyLjUgMi41IDAgMCAwIDIuNS0yLjVWNi45MzRBMS45OTggMS45OTggMCAwIDEgMTIgM20wIDFhMSAxIDAgMSAwIDAgMiAxIDEgMCAwIDAgMC0yIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26627-10448
*/
const Icon24SplitLarge = memo(function Icon24SplitLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 3a1.998 1.998 0 0 1 .5 3.934V8.5A2.5 2.5 0 0 0 15 11h.5a2.5 2.5 0 0 1 2.5 2.5v4.793l2.146-2.146a.5.5 0 0 1 .707.707l-3 3a.5.5 0 0 1-.113.082.5.5 0 0 1-.339.054.5.5 0 0 1-.164-.066l-.014-.007a.5.5 0 0 1-.077-.064l-3-3a.5.5 0 0 1 .707-.707L17 18.293V13.5a1.5 1.5 0 0 0-1.5-1.5H15a3.5 3.5 0 0 1-3-1.698A3.5 3.5 0 0 1 9 12h-.5A1.5 1.5 0 0 0 7 13.5v4.793l2.146-2.146a.5.5 0 1 1 .707.707l-3 3a.5.5 0 0 1-.113.082.5.5 0 0 1-.339.054.5.5 0 0 1-.142-.054.5.5 0 0 1-.113-.082l-3-3a.5.5 0 1 1 .707-.707L6 18.293V13.5A2.5 2.5 0 0 1 8.5 11H9a2.5 2.5 0 0 0 2.5-2.5V6.934A1.998 1.998 0 0 1 12 3m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
		})
	});
});
//#endregion
export { Icon24SplitLarge };

//# sourceMappingURL=icon-24-split-large.js.map